import React, { lazy, Suspense } from 'react';
import SEO from '../components/SEO';
import Hero from '../components/landing/Hero';

// Lazy load non-critical sections
const Features = lazy(() => import('../components/landing/Features'));
const Stats = lazy(() => import('../components/landing/Stats'));
const Testimonials = lazy(() => import('../components/landing/Testimonials'));
const CTASection = lazy(() => import('../components/landing/CTASection'));

export default function Landing() {
  return (
    <div className="min-h-screen">
      <SEO />
      
      {/* Hero Section with Dynamic Background */}
      <div className="relative bg-gradient-to-br from-teal-50 via-white to-teal-100">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80')] opacity-5"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-teal-100/80 via-white/90 to-teal-50/80"></div>
        </div>
        <Hero />
      </div>
      
      <Suspense fallback={<div className="h-32" />}>
        {/* Stats with Gradient Background */}
        <div className="relative bg-gradient-to-r from-teal-600 to-teal-700">
          <Stats />
        </div>
        
        {/* Features with Pattern Background */}
        <div className="relative bg-gray-50">
          <div className="absolute inset-0">
            <svg className="w-full h-full opacity-[0.15]" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
              <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <circle cx="3" cy="3" r="3" fill="#99f6e4" />
                <circle cx="13" cy="13" r="3" fill="#99f6e4" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#dots)" />
            </svg>
          </div>
          <Features />
        </div>
        
        {/* Testimonials with Subtle Gradient */}
        <div className="relative bg-gradient-to-b from-white to-teal-50/30">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80')] opacity-[0.02]"></div>
          <Testimonials />
        </div>
        
        {/* CTA Section */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-teal-600/20 to-teal-700/20"></div>
          <CTASection />
        </div>
      </Suspense>
    </div>
  );
}